/* src/app/deals/deals.component.scss */
.deal {
  font-size: 12px;
  border: 0 solid transparent;
  border-left-width: 16px;
}
.ml--4 {
  margin-left: -4px;
}
.mt--4 {
  margin-top: -4px;
}
.main-container,
.navigation-panel {
  -webkit-transition: 0s ease;
  -moz-transition: 0.5s ease;
  -o-transition: 0.5s ease;
  transition: 0.5s ease;
}
.navigation-panel {
  width: 0;
  left: 250px;
  z-index: 1000;
  position: fixed;
  margin-left: -250px;
}
.main-container.toggled {
  padding-left: 250px;
}
.main-container.toggled .navigation-panel {
  width: 250px;
}
.main-content {
  width: 100%;
  position: absolute;
}
.main-container.toggled .main-content {
  position: absolute;
  margin-right: -250px;
}
@media (min-width: 768px) {
  .main-container {
    padding-left: 250px;
  }
  .main-container.toggled {
    padding-left: 0;
  }
  .navigation-panel {
    width: 250px;
  }
  .main-container.toggled .navigation-panel {
    width: 0;
  }
  .main-content {
    position: relative;
  }
  .main-container.toggled .main-content {
    position: relative;
    margin-right: 0;
  }
}
/*# sourceMappingURL=deals.component.css.map */
